import React from 'react';
import {View, StyleSheet} from 'react-native';
import Carousel from 'react-native-reanimated-carousel';
import theme from '@/style';
import {BasicObject} from '@/types';
// import LazyImage from '@/components/basic/image';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import {useResponsiveDimensions} from '@/utils';
import {Image} from 'antd-mobile';
const LiveCarousel = ({
  bannerList = [],
  onPress = () => {},
}: {
  bannerList: BasicObject[];
  onPress: (info: BasicObject) => void;
}) => {
  const {width} = useResponsiveDimensions();

  const imageWidth = React.useMemo(() => {
    return (width * 147) / 375 + 8;
  }, [width]);

  return (
    <View style={[theme.margin.tbl, theme.padding.lrl]}>
      <Carousel
        width={imageWidth}
        height={(imageWidth / 448) * 256}
        vertical={false}
        loop
        style={[
          styles.container,
          bannerList.length === 0 && theme.background.gray, // 没有数据时，背景颜色为灰色
        ]}
        autoPlay
        pagingEnabled
        autoPlayInterval={3000}
        data={bannerList}
        renderItem={({item}) => (
          <NativeTouchableOpacity
            onPress={() => onPress(item)}
            style={styles.imageContainer}>
            <Image
              src={item.bannerImg}
              width={'100%'}
              height={'100%'}
              fallback={<div className="size-full bg-image" />}
            />
          </NativeTouchableOpacity>
        )}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  imageContainer: {
    flex: 1,
    marginRight: 8,
    borderRadius: 8,
    overflow: 'hidden',
  },
});

export default LiveCarousel;
